import React, { ChangeEvent } from 'react';
import { EventPicker } from '@v2/components/ui/EventPicker';
import { NumberTextField } from '@v2/components/ui/NumberTextField';
import { Stack } from '@mui/material';
import { Controller, useWatch } from 'react-hook-form';
import { fields, objectives, goalTypes } from '../constants';
import { GoalTypeAndAmountProps } from '../types';

export const GoalTypeAndAmount = ({
  control,
  value,
  setValue,
  ...props
}: GoalTypeAndAmountProps) => {
  const goalType = useWatch({
    control,
    name: fields.objectiveGoalType.path,
  });

  return (
    <Stack direction="row" spacing={2}>
      <Controller
        control={control}
        name={fields.objectiveGoalType.path}
        render={({ field, fieldState }) => {
          return (
            <EventPicker
              {...field}
              {...fieldState}
              {...props}
              id={value}
              label="Goal Type"
              helperText={fieldState.error?.message}
              eventSet={value ? objectives[value]?.goalTypes ?? [] : []}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                field.onChange(e);
                setValue(
                  fields.objectiveGoalValueMultiplier.path,
                  fields.objectiveGoalValueMultiplier.defaultValue,
                  { shouldDirty: true }
                );
                setValue(
                  fields.objectiveGoalValueCost.path,
                  fields.objectiveGoalValueCost.defaultValue,
                  { shouldDirty: true }
                );
              }}
            />
          );
        }}
      />
      {goalTypes[goalType] && (
        <Controller
          control={control}
          name={goalTypes[goalType]?.goalValue.path}
          render={({ field, fieldState }) => {
            return (
              <NumberTextField
                {...field}
                {...fieldState}
                error={!!fieldState.error}
                variant="outlined"
                fullWidth
                placeholder={goalTypes[goalType]?.goalValue?.placeHolder}
                label="Goal Value"
                decimalScale={goalTypes[goalType]?.goalValue?.decimalScale}
                inputAdornment={goalTypes[goalType]?.goalValue?.symbol}
                helperText={fieldState.error?.message}
                value={field.value || ''} // force re-render
              />
            );
          }}
        />
      )}
    </Stack>
  );
};
